import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { get } from 'utils';
import { withData } from './data';

import { WatchlistAutocompleteUI } from './ui';

export class WatchlistAutocomplete extends PureComponent {
    static displayName = 'WatchlistAutocompleteContainer';

    static propTypes = {
        autoFocus: PropTypes.bool,
        initialSearchTerm: PropTypes.string,
        multi: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        styles: PropTypes.objectOf(PropTypes.any),
        options: PropTypes.arrayOf(PropTypes.any),
        placeholder: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    };

    static defaultProps = {
        autoFocus: false,
        initialSearchTerm: null,
        styles: undefined,
        multi: false,
        options: [],
        placeholder: 'Select watchlists',
        name: 'watchlistAutocomplete',
        value: null
    };

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange({ event, name, value }) {
        const { onChange, options } = this.props;
        const label = get(
            options.find(({ value: id }) => id === value),
            'label'
        );

        onChange({ event, name, value, label });
    }

    render() {
        const { autoFocus, initialSearchTerm, multi, styles, placeholder, options, name, value } = this.props;
        return (
            <WatchlistAutocompleteUI
                autoFocus={autoFocus}
                initialSearchTerm={initialSearchTerm}
                multi={multi}
                onChange={this.onChange}
                name={name}
                options={options}
                placeholder={placeholder}
                styles={styles}
                value={value}
            />
        );
    }
}

export const WatchlistAutocompleteContainer = compose(withData())(WatchlistAutocomplete);
